'use client'

import { StatsLeaders } from '@/components/custom/stats/stats-leaders'

export function StatsPage() {
  return (
    <div className="py-6 space-y-4">
      <h1 className="text-[1.75rem] font-bold tracking-tight leading-none">Stats</h1>
      <StatsLeaders />
    </div>
  )
}
